function canUseDOM(): boolean {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

export const isBrowser = canUseDOM();

export const isDev = isBrowser && /(www.)?(staging\.|dev\.|localhost:)/.test(document.location.host);

export const isLocalDev = isBrowser && /(www.)?(localhost:)/.test(document.location.host);
